var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"role":"none"}},[_c('img',{attrs:{"src":_vm.staticMapSrc,"alt":_vm.$t('enabled-locations-map.map-showing-data-center-location')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }